//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '~/net/portal';
import { requiredInput, phoneReg, ssfzxJy } from '~/constant/validform';
const pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{10,}$/;
export default {
  // layout: 'onlyHeader',
  head() {
    return {
      title: '用户注册',
    };
  },
  data() {
    return {
      step: 0,
      form: {
        phone: '',
        verifyImgCode: '',
        verifyCode: '',
        ssfzx: '',
      },
      registerform: {
        password: '',
        conformPassword: '',
      },

      // 所属分中心下拉列表
      ssfzxList: [],
      // 所属分中心默认选项
      ssfzxBc: '',

      rules: {
        phone: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入手机号码'));
              } else if (!phoneReg.test(value)) {
                callback(new Error('手机号码无效'));
              } else {
                portal
                  .isPhoneExist({
                    query: { phone: this.form.phone },
                  })
                  .then((res) => {
                    if (res.data == true) {
                      callback(new Error('该手机号已存在'));
                    } else {
                      callback();
                    }
                  })
                  .catch(() => {
                    callback();
                  });
              }
            },
          },
        ],
        verifyImgCode: requiredInput('请输入验证码'),
        verifyCode: requiredInput('请输入验证码'),
        ssfzx: ssfzxJy,

        password: [
          {
            required: true,
            trigger: 'change',
            validator: this.passwordValidate,
          },
        ],
        conformPassword: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请再次输入密码'));
              } else if (value !== this.registerform.password) {
                callback(new Error('密码输入不一致'));
              } else {
                callback();
              }
            },
          },
        ],
      },
      verifyCodeImgClick: 0,
      randomCode: '',
      creattime: new Date(),
      count: '',
      count1: '',
      timer: null,
      timer1: null,
      yzm: true,
      isVisble: false,
      portocol: {},
      bindOpenidDto: null,
      callback: '/',
    };
  },
  computed: {
    verifyCodeImg() {
      return '/portal/getCaptchaCode?' + this.verifyCodeImgClick;
    },
  },
  watch: {
    'form.ssfzx'(newVal) {
      this.ssfzxBc = newVal;
      console.log(this.ssfzxBc);
    },
  },
  created() {
    this.step = this.$route.query.step ? this.$route.query.step : 0;
    const { callback } = this.$route.query;
    if (callback != undefined) {
      this.callback = decodeURI(this.$route.query.callback);
    } else {
      this.callback = '/';
    }
    const { randomCode, bindOpenidDto } = this.$route.params;
    if (randomCode && bindOpenidDto) {
      this.step = 1;
      this.randomCode = randomCode;
      this.bindOpenidDto = bindOpenidDto;
    }

    this.getTenant();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.timer1) {
      clearInterval(this.timer1);
    }
  },
  methods: {
    getSmsCodeForSignUp() {
      portal
        .getSmsCodeForSignUp({
          query: {
            phone: this.form.phone,
            imgVerifyCode: this.form.verifyImgCode,
          },
        })
        .then((res) => {
          if (res.code == '0000') {
            this.yzm = false;
            this.countdown();
            this.$Message.success('验证码已发送到您的手机');
          } else {
            this.yzm = true;
            this.verifyCodeClick();
          }
        });
    },
    passwordValidate(rule, value, callback) {
      const reg = new RegExp(pwdReg);
      if (!value) {
        callback(new Error('密码不能为空'));
      } else if (value.length < 10) {
        callback(new Error('长度不能小于10位'));
      } else if (value.length > 30) {
        callback(new Error('长度不能大于30位'));
      } else if (!reg.test(value)) {
        callback(new Error('密码需由数字和字母组成，至少10位'));
      } else {
        callback();
      }
    },
    checkSmsCodeForSignUp() {
      this.$refs.register1.validate((valid) => {
        if (valid) {
          portal
            .checkSmsCodeForSignUp({
              query: {
                phone: this.form.phone,
                imgVerifyCode: this.form.verifyImgCode,
                smsVerifyCode: this.form.verifyCode,
              },
            })
            .then((res) => {
              if (res.code == '0000') {
                this.randomCode = res.data;
                this.step = 1;
              } else {
                this.form.verifyCode = '';
              }
            });
        }
      });
    },
    verifyCodeClick() {
      this.verifyCodeImgClick++;
      this.form.verifyImgCode = '';
    },
    // 注册
    setPasswordForSignUp2() {
      console.log(1111111111);
      this.$refs.register2.validate((valid) => {
        if (valid) {
          this.$api
            .setPasswordForSignUp2(this.randomCode, this.ssfzxBc, {
              ...this.registerform,
              bindOpenidDto: this.bindOpenidDto,
            })
            .then((res) => {
              const { code, message } = res;
              console.log(res);
              if (code === '0000') {
                this.step = 2;
                this.redirectToHome();
              } else {
                this.$Message.error(message);
              }
            });
        }
      });
    },
    redirectToHome() {
      const TIME_COUNT = 3;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            window.location.href = this.callback;
          }
        }, 1000);
      }
    },
    countdown() {
      const TIME_COUNT = 60;
      this.count1 = TIME_COUNT;
      this.show = false;
      this.timer1 = setInterval(() => {
        if (this.count1 > 0 && this.count1 <= TIME_COUNT) {
          this.count1--;
        } else {
          this.yzm = true;
        }
      }, 1000);
    },
    async getProtocol(portocalType) {
      const resp = await portal.getProtocol({
        query: { type: portocalType },
      });
      if (resp.code == '0000') {
        this.isVisble = true;
        this.portocol = resp.data;
        this.portocol.title = portocalType == '02' ? '用户隐私条款' : '用户注册协议';
      }
    },

    // 获取所属分中心
    async getTenant() {
      const resp = await portal.getTenant({});
      if (resp.code == '0000') {
        this.ssfzxList = resp.data;
      }
    },
  },
};
